import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0021',
    ecrans: ['00-2'],
    params: ['id', '?type']
});
